export default __webpack_public_path__ + "static/media/undraw_Mail_sent_qwwx.0de5d459.svg";